"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _glamor = require("glamor");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _SavedPaymentDetails = require("@quixeltools/quixel-ui-library/dist/components/common/checkout/SavedPaymentDetails");

var _SavedPaymentDetails2 = _interopRequireDefault(_SavedPaymentDetails);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Checkbox = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _TextInput = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextInput");

var _TextInput2 = _interopRequireDefault(_TextInput);

var _Form = require("@quixeltools/quixel-ui-library/dist/components/common/website/Form");

var _Form2 = _interopRequireDefault(_Form);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _components = require("components");

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var footer = function footer(hasBackLink) {
  return (0, _glamor.css)({
    display: "flex",
    alignItems: "center",
    justifyContent: hasBackLink ? "space-between" : "flex-end",
    marginTop: (0, _css.unitRem)(1.5)
  });
};

var tos = (0, _glamor.css)({
  color: _css.colors.gray
});

var leftArrow = (0, _glamor.css)({
  display: "inline-block",
  width: (0, _css.unitRem)(0.625),
  height: (0, _css.unitRem)(0.625),
  border: "none",
  borderLeft: "1px solid " + _css.colors.gray,
  borderBottom: "1px solid " + _css.colors.gray,
  transform: "rotate(45deg)"
});

var backButton = (0, _glamor.css)({
  float: "left",
  color: _css.colors.gray,
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  paddingTop: "1.05em",
  paddingBottom: "1.2em",
  fontWeight: 300,
  textDecoration: "none",
  fontSize: (0, _css.unitRem)(1)
});

var backButtonContent = (0, _glamor.css)({
  marginLeft: "6px",
  ":after": {
    content: '"Back"'
  }
}, (0, _css.minWidth)(_css.breakpoints.mediumlarge)({
  ":after": {
    content: '"Back to settings"'
  }
}));

var fields = (0, _glamor.css)({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "3em"
});

var applyButton = (0, _glamor.css)({
  flexBasis: "50%",
  marginTop: (0, _css.unitRem)(1.95),
  paddingLeft: (0, _css.unitRem)(0.833)
});

var promoCodeField = (0, _glamor.css)({
  marginTop: "1.5em",
  flexBasis: "100%"
});

var promoCodeMessage = (0, _glamor.css)({
  display: "block",
  color: _css.colors.gray,
  marginTop: "0.375em"
});

var tosLink = (0, _glamor.css)({
  fontSize: "1em",
  "& a": {
    paddingLeft: "0px"
  }
});

// const billingDetailsAppendix = makingPayment => (
//   <Checkbox
//     disabled={makingPayment}
//     label="Subscribe to Megascans Newletter"
//   />
// )

var paymentDetailsAppendix = function paymentDetailsAppendix(props) {
  var billing = undefined;
  if (props.paymentItem && props.paymentItem.billing) {
    billing = props.paymentItem.billing;
  }

  // billing will only be undefined in the case of purchasing points

  return _react2.default.createElement(
    "div",
    null,
    props.showPromoCode && _react2.default.createElement(
      "div",
      { className: fields },
      _react2.default.createElement(_TextInput2.default, (0, _extends3.default)({
        errorBelow: true,
        className: promoCodeField,
        disabled: props.makingPayment || props.isAnnualSubscription,
        label: "Promo Code",
        loading: props.validatingPromoCode,
        icon: "acquire",
        isValidResult: props.promoCodeMessage
      }, props.promoCode)),
      props.showPromoCode && props.promoCodeMessage && _react2.default.createElement(
        "span",
        { className: promoCodeMessage },
        props.promoCodeMessage
      ),
      props.isAnnualSubscription && _react2.default.createElement(
        "span",
        { className: promoCodeMessage },
        "* Promo codes do not apply to annual subscriptions"
      )
    ),
    props.renderCaptcha(props.fields.captcha),
    _react2.default.createElement(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        } },
      _react2.default.createElement(_Checkbox2.default, (0, _extends3.default)({
        disabled: props.makingPayment,
        simpleError: true
      }, props.acceptTos, {
        checked: props.checked,
        onChange: function onChange(e) {
          props.onChangeHandler();
          props.acceptTos.onChange(e);
        }
      })),
      _react2.default.createElement(
        "span",
        { className: tos },
        "By checking this box, you confirm you meet the age requirement, agree to the\xA0",
        _react2.default.createElement(_components.TextButtonLibrary, {
          className: tosLink,
          mode: "small-gray-underlined",
          href: "https://www.unrealengine.com/en-US/eula/content",
          label: " Content License Agreement",
          newWindow: true
        }),
        "and authorize us to charge your payment method. We use BrainTree for payment processing which requires you to accept BrainTree\u2019s\xA0",
        _react2.default.createElement(_components.TextButtonLibrary, {
          className: tosLink,
          mode: "small-gray-underlined",
          href: "https://www.braintreepayments.com/legal/payment-services-agreement",
          label: " terms and conditions",
          newWindow: true
        }),
        "to proceed with the transaction.\xA0",
        _react2.default.createElement("br", null),
        _react2.default.createElement("br", null),
        billing && _react2.default.createElement(
          "div",
          null,
          "You will be billed ",
          billing === "annual" ? "annually" : "monthly",
          " until you cancel your subscription. Learn\xA0",
          _react2.default.createElement(_components.TextButtonLibrary, {
            className: tosLink,
            mode: "small-gray-underlined",
            href: _config2.default.forumBaseUrl,
            label: " how to cancel",
            newWindow: true
          }),
          "at any time."
        )
      )
    )
  );
};

var SavedPaymentDetailsCheckout = function (_React$Component) {
  (0, _inherits3.default)(SavedPaymentDetailsCheckout, _React$Component);

  function SavedPaymentDetailsCheckout(props) {
    (0, _classCallCheck3.default)(this, SavedPaymentDetailsCheckout);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SavedPaymentDetailsCheckout.__proto__ || (0, _getPrototypeOf2.default)(SavedPaymentDetailsCheckout)).call(this, props));

    _this.onChangeHandler = _this.onChangeHandler.bind(_this);

    _this.state = {
      termsChecked: false
    };
    return _this;
  }

  (0, _createClass3.default)(SavedPaymentDetailsCheckout, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.updatePrice(this.props.billingDetails.countryCode, this.props.billingDetails.state, this.props.billingDetails.city, this.props.billingDetails.postalCode, this.props.billingDetails.vatNo, true, this.props.billingDetails.mainDivision);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // this.setState({ termsChecked: !this.props.shouldUpdateEula });
      this.setState({ termsChecked: false });
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      // if (nextProps.shouldUpdateEula !== this.props.shouldUpdateEula) {
      //   this.setState({ termsChecked: !nextProps.shouldUpdateEula });
      // }
    }
  }, {
    key: "onChangeHandler",
    value: function onChangeHandler() {
      this.setState({
        termsChecked: !this.state.termsChecked
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      return _react2.default.createElement(
        _Form2.default,
        { onSubmit: props.handleSubmit, error: props.error },
        _react2.default.createElement(_SavedPaymentDetails2.default, (0, _extends3.default)({}, props, {
          paymentDetailsAppendix: paymentDetailsAppendix((0, _extends3.default)({}, props, {
            onChangeHandler: this.onChangeHandler,
            checked: this.state.termsChecked
          }))
        })),
        _react2.default.createElement(
          "div",
          { className: footer(!!props.backLink) },
          props.backLink && _react2.default.createElement(
            _reactRouter.Link,
            {
              className: backButton,
              to: {
                pathname: props.backLink,
                state: { comingBackFromNextPage: true }
              } },
            _react2.default.createElement("span", { className: leftArrow }),
            _react2.default.createElement("span", { className: backButtonContent })
          ),
          _react2.default.createElement(_Button2.default, {
            type: "submit",
            mode: "secondary",
            label: "Confirm Purchase",
            disabled: props.makingPayment || !this.state.termsChecked,
            loading: props.makingPayment
          })
        )
      );
    }
  }]);
  return SavedPaymentDetailsCheckout;
}(_react2.default.Component);

exports.default = SavedPaymentDetailsCheckout;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SavedPaymentDetailsForm/SavedPaymentDetailsCheckout.jsx
// module id = 2819
// module chunks = 0